import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import CakeIcon from '@mui/icons-material/Cake';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export function InfoPersonalCliente({ cliente }) {
    const formatearFecha = (fechaString) => {
        const fecha = new Date(fechaString);
        return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    return (
        <div className="mb-6 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-200">
            <div className="flex items-center gap-2 mb-3">
                <PersonIcon className="text-blue-600" sx={{ fontSize: 20 }} />
                <h3 className="text-lg font-bold text-gray-800">Datos del Cliente</h3>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase">Nombre</label>
                    <p className="text-sm font-bold text-gray-800">{cliente.nombre}</p>
                </div>
                <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase">N° Cliente</label>
                    <p className="text-sm font-bold text-gray-800">{cliente.numero}</p>
                </div>
                <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
                        <BadgeIcon sx={{ fontSize: 14 }} /> Cédula/RUC
                    </label>
                    <p className="text-sm font-bold text-gray-800">{cliente.ruc}</p>
                </div>
                <div>
                    <label className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
                        <CakeIcon sx={{ fontSize: 14 }} /> Fecha Nacimiento
                    </label>
                    <p className="text-sm font-bold text-gray-800">{formatearFecha(cliente.fechaNacimiento)}</p>
                </div>
                <div className="col-span-2">
                    <label className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
                        <PhoneIphoneIcon sx={{ fontSize: 14 }} /> Celular Principal
                    </label>
                    <p className="text-sm font-bold text-blue-600 flex items-center gap-1">
                        {cliente.celular}
                    </p>
                </div>
            </div>
        </div>
    );
}
